import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { pagingComplaintTicket, pagingReviewFeedback } from "app/services/ComplaintService";
import { getPatientOverviewById } from "app/services/PatientService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class ReviewFeedbackStore {
  searchReviewFeedback = {
    ...new SearchObject(),
    // isCustomerCare: true,
    clientId: null,
    emrMappingId: null,
  };
  pageRegisterReviewFeedback = new PageResponse();
  dataVoucherFeedback = null;
  constructor() {
    makeAutoObservable(this);
  }
  getDataReviewFeedback = async () => {
      try {
        const { data } = await pagingReviewFeedback(this.searchReviewFeedback);
        this.pageRegisterReviewFeedback = {
          ...data,
          content: data.content,
        };
        this.dataVoucherFeedback = data;
      } catch (error) {
        console.error(error);
        toast.error("Lấy dữ liệu cskh có lỗi");
      }
    };
  handleChangeFormSearchReviewFeedback = (searchReviewFeedback) => {
    this.searchReviewFeedback = {
      ...this.searchReviewFeedback,
      ...searchReviewFeedback,
    };
    this.getDataReviewFeedback();
  };

}
